import React, { FC } from 'react';
import { Row } from 'antd';
import { CountdownTimer, TextHeadline } from 'components';
import { ContainerAlternative } from 'containers';
import { Spacer } from 'components/Spacer';
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

export const SectionCountDown: FC = () => {
	const date = new Date('09/7/2021');
	return (
		<ContainerAlternative center>
			<Spacer />
			<Row justify={'center'}>
				<TextHeadline dense>
					Live Auction starting on <strong>{date.toDateString()}</strong> at
					<strong> {dayjs(date).format('LT')}</strong>.
				</TextHeadline>
			</Row>
			<Spacer height={'xs'} />
			<Row justify={'center'}>
				<CountdownTimer toDate={date} />
			</Row>
		</ContainerAlternative>
	);
};
